module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ed-checkbox"
  }, [_c('input', {
    staticClass: "ed-checkbox__input",
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "id": _vm.id,
      "disabled": _vm.disabled,
      "tabindex": "-1"
    },
    domProps: {
      "checked": _vm.isChecked,
      "value": _vm.value
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleCheck($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ed-checkbox__label",
    attrs: {
      "for": _vm.id
    }
  }, [(_vm.$slots.default) ? _c('span', {
    staticClass: "ed-checkbox__label-text"
  }, [_vm._t("default")], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1993e6d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/edoc-library/src/components/checkbox/checkbox.vue
// module id = 695
// module chunks = 42